import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../utils/theme-context';

const Button = ({ children, onClick, className = '', animate = false, ...props }) => {
  const { theme } = useTheme();
  return (
    <motion.button
      whileTap={animate ? { scale: 0.95 } : {}}
      className={`px-5 py-2 font-bold border-4 border-black transition ${className}`}
      style={{
        borderRadius: 0,
        boxShadow: theme.boxShadow,
        background: theme.buttonBg,
        color: theme.buttonColor,
        fontFamily: theme.fontFamily,
      }}
      onClick={onClick}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button; 